import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography, IconButton } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';
import { YES_NO } from '../../../../../constants';

export const PersonalHistoryDetailsForm = ({ onAdd, onClose, setPersonalHistoryDialog }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
 
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = (formValue) => {
    onAdd(formValue);
    setPersonalHistoryDialog(false);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}>
        <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: "2%", fontSize: "1.5rem", color: "#333" }}>
          Personal History
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'red' }}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Stack>

      <Grid container spacing={2} sx={{ marginTop: 3 }}>
        <Grid item xs={12} sm={6}>
          <Stack spacing={2}>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Breast Discharge</Typography>
              <TextField sx={{ flex: 1 }} name="breast_discharge" placeholder="Breast Discharge" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Hirsutism</Typography>
              <TextField sx={{ flex: 1 }} name="hirustism" placeholder="Hirsutism" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>White Discharge</Typography>
                  <TextField sx={{ flex: 1 }} name="white_discharge" variant="outlined" />
                </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Dysmenorrhea</Typography>
              <TextField sx={{ flex: 1 }} name="dysmenorrhea" placeholder="Dysmenorrhea"  variant="outlined" />
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Stack spacing={2}>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Side</Typography>
              <TextField sx={{ flex: 1 }} name="breast_side" placeholder="Previous Cycle Type" variant="outlined" />
            </Stack>

            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.2rem' }}>Type</Typography>
              <TextField sx={{ flex: 1 }} name="discharge_type" placeholder="Type" variant="outlined" />
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Stack spacing={2}>
            {/* Properly aligned Dysmenorrhea and Dysmenorrhea Type */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
           
              </Grid>
            </Grid>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
              <Typography sx={{ flex: 0.15, fontWeight: 600, fontSize: '1.2rem' }}>Details</Typography>
              <TextField sx={{ flex: 1 }} name="details" multiline rows={4} variant="outlined" />
            </Stack>
          </Stack>
        </Grid>
      </Grid>

      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{ marginTop: 3 }}>
        <Button variant="contained" type="submit"  >
          Add
        </Button>
        <Button color="error" onClick={onClose} >
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
